export {
  ocrTemplateQueries,
  ocrTemplateKeys
} from './services/ocr-templates.queries';
export { ocrTemplatesApi } from './services/ocr-templates.api';
export {
  discoveredFieldQueries,
  discoveredFieldKeys
} from './services/discovered-fields.queries';
export { discoveredFieldsApi } from './services/discovered-fields.api';
export {
  fieldHistoryQueries,
  fieldHistoryKeys
} from './services/field-history.queries';
export { fieldHistoryApi } from './services/field-history.api';
export {
  useApproveDiscoveredFieldMutation,
  useRejectDiscoveredFieldMutation,
  useResetDiscoveredFieldMutation,
  useIgnoreDiscoveredFieldMutation,
  useUpdateDiscoveredFieldDescriptionMutation,
  useBulkDecideDiscoveredFieldsMutation,
  discoveredFieldDecisionInvalidationKeys
} from './services/discovered-fields.mutations';
export {
  useCreateOcrTemplateMutation,
  useUpdateOcrTemplateMutation,
  useDeleteOcrTemplateMutation,
  useBulkDeleteOcrTemplatesMutation,
  useSyncCustomFieldsMutation,
  useArchiveFieldMutation,
  useRestoreArchivedFieldMutation,
  useSyncFieldRulesMutation,
  useGenerateOcrTemplateDescriptionMutation
} from './services/ocr-templates.mutations';
export { OcrTemplatesListing } from './components/ocr-templates-listing';
export { TemplateFieldsInfo } from './components/template-fields-info';
// The one 0-100 match-percentage control (OMA-665) — the supervisor's reject
// dialog sets a rejection radius with the same lever the template uses.
export { MatchThresholdSlider } from './components/match-threshold-slider';
// Exported for the supervisor's discovered-field approval dialog: approving a
// field edits the same label / English label / description / colour a template
// field carries, so it reuses this form rather than growing a fourth copy of it.
export { AddCustomFieldDialog } from './components/add-custom-field-dialog';
export type { CustomFieldFormValues } from './components/add-custom-field-dialog';
export type {
  OcrTemplate,
  OcrTemplateCustomField,
  OcrTemplateFieldRule,
  OcrTemplateSuggestion,
  OcrCustomFieldType,
  RuleOperator,
  OcrTemplatesListParams,
  OcrTemplateArchivedFieldsParams,
  CreateOcrTemplateRequest,
  UpdateOcrTemplateRequest,
  SyncCustomFieldsRequest,
  SyncFieldRulesRequest,
  GenerateDescriptionRequest,
  OcrDiscoveredField,
  DiscoveredFieldStatus,
  DiscoveredFieldOrigin,
  OcrDiscoveredFieldsListParams,
  OcrDiscoveredFieldMetrics,
  ApproveDiscoveredFieldRequest,
  RejectDiscoveredFieldRequest,
  OcrDiscoveredFieldTemplate,
  OcrDiscoveredFieldContainer,
  OcrDiscoveredFieldTemplatesParams,
  OcrDiscoveredFieldContainersParams,
  OcrDiscoveredFieldGroup,
  OcrDiscoveredFieldGroupsParams,
  OcrDiscoveredFieldFile,
  OcrDiscoveredFieldFilesParams,
  OcrTemplateFieldHistoryEntry,
  OcrTemplateFieldHistoryResponse
} from './types';
